import React, { Component } from 'react';

import ArcgisFilter from 'arcgis-filter';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Popover from 'material-ui/Popover';
import DownArrowIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';

import SavedFilters from './SavedFilters';
class ResourceSqlFilterDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: null,
      filterState: null
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.filterState && !prevState.filterState) {
      const f = JSON.parse(JSON.stringify(nextProps.filterState));
      return { filterState: f };
    }
    return null;
  }

  handleCancel = () => {
    this.setState({
      filter: null,
      filterState: null
    });
    this.props.onCancel();
  };

  handleSubmit = () => {
    const update = {
      ...this.state,
      favoritesAnchor: null
    };

    const state = JSON.parse(JSON.stringify(update));
    this.props.onSubmit(state);
  };

  handleChange = (filter, filterState) => {
    const f = JSON.parse(JSON.stringify(filterState));
    this.setState({ filter, filterState: f, appliedFavorite: null });
  };

  handleFilterNameChanged = e => {
    this.setState({ filterName: e.target.value });
  };

  handleSaveNewFilter = filterName => {
    const filterState = JSON.parse(JSON.stringify(this.state.filterState));
    this.props.onSaveFilter(filterName, filterState);
  };

  handleSaveExistingFilter = (existingFilterName, newFilterName) => {
    this.props.onRenameFilter(existingFilterName, newFilterName);
  };

  handleSavedFilterSelected = (filterState, filterName) => {
    const f = JSON.parse(JSON.stringify(filterState));
    this.setState({
      filterState: f,
      favoritesOpen: false
    });
  };

  handleSavedFilterDeleted = filterName => {
    this.props.onDeleteFilter(filterName);
  };

  handleFavoritesClose = () => {
    this.setState({ favoritesOpen: false });
  };

  showFavorites = e => {
    e.preventDefault();
    this.setState({ favoritesOpen: true, favoritesAnchor: e.currentTarget });
  };

  getFields(fieldDefinitions) {
    const updatedFields = this.epochsToDates(fieldDefinitions);
    return updatedFields;
  }

  epochsToDates(fields) {
    // WORKAROUND for 2 "date" fields that are actually numbers...
    const updatedFields = { ...fields };
    updatedFields['CreatedOnDateTime'].type = 'epoch';
    updatedFields['ModifiedOnDateTime'].type = 'epoch';

    return updatedFields;
  }

  render() {
    const { filterState } = this.state;
    return (
      <Dialog
        open={true}
        autoScrollBodyContent
        contentStyle={styles.modalContent}
        actions={[
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleCancel}
          />,
          <FlatButton
            label="Submit"
            primary={true}
            onClick={this.handleSubmit}
          />
        ]}
      >
        >
        <div>
          <div style={styles.header}>
            <h1 style={styles.headText}>Resources Filter</h1>
            <FlatButton
              label="Favorites"
              labelPosition="before"
              icon={<DownArrowIcon />}
              onClick={this.showFavorites}
            />
          </div>
          <Popover
            open={this.state.favoritesOpen}
            anchorEl={this.state.favoritesAnchor}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            targetOrigin={{ horizontal: 'right', vertical: 'top' }}
            onRequestClose={this.handleFavoritesClose}
            style={styles.favoritesContainer}
          >
            <SavedFilters
              filters={this.props.savedFilters}
              onSaveNewFilter={this.handleSaveNewFilter}
              onSaveExistingFilter={this.handleSaveExistingFilter}
              onFilterSelected={this.handleSavedFilterSelected}
              onFilterDeleted={this.handleSavedFilterDeleted}
            />
          </Popover>
          <ArcgisFilter
            filterState={{ ...filterState }}
            fields={this.getFields(this.props.fieldDefinitions)}
            disableUnique={true}
            onChange={this.handleChange}
          />
        </div>
      </Dialog>
    );
  }
}

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  headText: {
    fontWeight: '400',
    color: 'rgba(76, 76, 76)',
    fontSize: '2.4rem'
  },
  modalContent: {
    maxWidth: 'none'
  }
};

export default ResourceSqlFilterDialog;



// WEBPACK FOOTER //
// ./src/components/dispatches/ResourcePanels/ResourceSqlFilterDialog.js